module.exports = __webpack_public_path__ + "static/img/2c.9075465.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/medio-ambiente-en/2c.png
// module id = N1q+
// module chunks = 0